/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import {client} from '../Client';
import { Form, Header } from 'semantic-ui-react'
import PropTypes from 'prop-types';

class FiltriMultiDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipo: this.props.tipo,
            selectedValues: [],
            itemList: [],
            dropdownLoading: false,
        };
        this.lastNewValue = undefined;
        this.onChange = this.onChange.bind(this);
        this.onLoading = this.onLoading.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
    }

    onLoading(value){
        this.setState({ dropdownLoading: value });
        if (this.props.onLoading !== undefined){
            this.props.onLoading(value)
        }
    }

    arrayToCombo(items, addEmpty = true){


        let list = [];
        if (addEmpty === true){
            list.push({ key: '', text: '', value: null, content:null})
        }
        items.map((item) => {
            let cnt = <div className="sub header">{item.descrizione}<br/><em>{item.valore}</em></div>
            list.push({
                key: item.idFiltro,
                text: item.nome,
                value: JSON.stringify(item),
                content: (<Header icon={null} content={item.nome} subheader={ cnt }/>)
            })
            return 0;
        })
        return list;


    }

    loadDropdown(){
        this.onLoading(true);
        client.loadFiltriPerTipoList(this.state.tipo).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.onLoading(false);
                    this.setState({
                        error: null,
                        itemList: this.arrayToCombo(data)
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.onLoading(false);
                    this.setState({
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.onLoading(false);
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    onChange(ev, {name, value}){
        if (this.props.onChange !== undefined)
        {
            this.props.onChange(ev, {name, value})
        }
    }

    onSearchChange(ev, value){

    }

    componentWillMount() {
        this.loadDropdown();
    }

    render() {
        return (
            <Form.Dropdown
                label={this.props.label}
                name={this.props.name} fluid multiple selection search
                selectOnBlur={false}
                placeholder={this.props.placeholder}
                loading={this.state.dropdownLoading}
                options={this.state.itemList}
                value={this.props.value}
                error={this.props.error}
                required={this.props.required}
                onChange={this.onChange}
                onSearchChange={this.onSearchChange}
                style={{minHeight: "50px", zIndex: "1000"}}
            ></Form.Dropdown>
        )
    }
}

FiltriMultiDropdown.PropTypes = {
    tipo: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    required: PropTypes.number.isRequired,
    additionLabel: PropTypes.string.isRequired,
    value: PropTypes.string,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onLoading: PropTypes.func.isRequired,
};

FiltriMultiDropdown.defaultProps = {
    required: false,
    placeholder: 'Seleziona uno o più filtri preconfigurati'
};

FiltriMultiDropdown.contextTypes = {
    router: PropTypes.object
}

export default FiltriMultiDropdown;



/** WEBPACK FOOTER **
 ** ./src/components/FiltriMultiDropdown.jsx
 **/